export default __webpack_public_path__ + "static/media/ring.14ae9efd.png";